import { Map } from 'immutable'
import * as ACTIONS from './actions'

export const initialState = Map({
  portals: Map(),
})

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case ACTIONS.PM_PORTALS_SET_PROCESSING:
      return state.setIn(['processing'], true)
    case ACTIONS.PM_PORTALS_SET:
      return state
        .set('portals', payload.portals)
        .setIn(['processing'], false)
    case ACTIONS.PM_PORTALS_SET_ERROR:
      return state
        .setIn(['error'], payload.error)
        .setIn(['processing'], false)
    default:
      return state
  }
}
